var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZerobalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_110_5205)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 45,
    fill: "#C4E5F1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.504 65C23.0396 65 22.6174 64.8854 22.2374 64.6562C21.8574 64.4271 21.5619 64.125 21.3508 63.75C21.1397 63.375 21.0235 62.9688 21.0024 62.5312C20.9813 62.0938 21.0974 61.6667 21.3508 61.25L44.7834 21.25C45.0367 20.8333 45.3639 20.5208 45.765 20.3125C46.1661 20.1042 46.5778 20 47 20C47.4222 20 47.8339 20.1042 48.235 20.3125C48.6361 20.5208 48.9633 20.8333 49.2166 21.25L72.6492 61.25C72.9026 61.6667 73.0187 62.0938 72.9976 62.5312C72.9765 62.9688 72.8603 63.375 72.6492 63.75C72.4381 64.125 72.1426 64.4271 71.7626 64.6562C71.3826 64.8854 70.9604 65 70.496 65H23.504ZM27.8739 60H66.1261L47 27.5L27.8739 60ZM47 57.5C47.7178 57.5 48.3194 57.2604 48.8049 56.7812C49.2905 56.3021 49.5333 55.7083 49.5333 55C49.5333 54.2917 49.2905 53.6979 48.8049 53.2188C48.3194 52.7396 47.7178 52.5 47 52.5C46.2822 52.5 45.6806 52.7396 45.1951 53.2188C44.7095 53.6979 44.4667 54.2917 44.4667 55C44.4667 55.7083 44.7095 56.3021 45.1951 56.7812C45.6806 57.2604 46.2822 57.5 47 57.5ZM47 50C47.7178 50 48.3194 49.7604 48.8049 49.2812C49.2905 48.8021 49.5333 48.2083 49.5333 47.5V40C49.5333 39.2917 49.2905 38.6979 48.8049 38.2188C48.3194 37.7396 47.7178 37.5 47 37.5C46.2822 37.5 45.6806 37.7396 45.1951 38.2188C44.7095 38.6979 44.4667 39.2917 44.4667 40V47.5C44.4667 48.2083 44.7095 48.8021 45.1951 49.2812C45.6806 49.7604 46.2822 50 47 50Z",
    fill: "#00537C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_110_5205",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78696 0 0 0 0 0.78696 0 0 0 0 0.78696 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_5205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_5205",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZerobalance);
export default __webpack_public_path__ + "static/media/zerobalance.6322af20c1602f6ed4362dae7cc72f40.svg";
export { ForwardRef as ReactComponent };